<template>
    <alert-modal
        :title="$t('MOUSE_LEAVE_MODAL_TITLE')"
        :superTitle="$t('MOUSE_LEAVE_MODAL_SUPER')"
        @close="close"
        data-cz-component="mouseLeaveModal"
        class="cz2__mouse-leave-modal"
    >
        <div class="cz2__modal-popup__copy">
            {{ $t('MOUSE_LEAVE_MODAL_COPY') }}
        </div>

        <div class="cz2__modal-popup__buttons">
            <btn
                primary
                narrow
                @click="close"
            >
                {{ $t('MOUSE_LEAVE_MODAL_PRIMARY') }}
            </btn>
        </div>
    </alert-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__mouse-leave-modal {
            .cz2__modal-popup__copy {
                margin-bottom: 24px;
            }

            .cz2__modal-popup__buttons {
                padding-bottom: 8px;
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;

                .cz2__btn {
                    height: 40px;
                    font-size: 16px;

                    &:focus {
                        &:before {
                            // Prevent focus styles from showing unwanted scrollbars
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';

    import Btn from './ui/Btn.vue';

    export default {
        components: {
            AlertModal,
            Btn,
        },

        methods: {
            close() {
                this.$store.dispatch('showMouseLeaveModal', false);
            },
        },
    };
</script>
